import { computed, ref } from 'vue'

export function useTrustedShops(shopId: string) {
  const data = ref({
    orderNr: '',
    email: '',
    amount: '',
    currency: '',
    paymentType: ''
  })

  const encodedEmail = computed(() => btoa(data.value.email))
  const encodedOrderNr = computed(() => btoa(data.value.orderNr))

  const reviewLink = computed(() => {
    return `https://www.trustedshops.de/bewertung/bewerten_${shopId}.html&?buyerEmail=${encodedEmail.value}&shopOrderID=${encodedOrderNr.value}`
  })

  return {
    data,
    reviewLink
  }
}
